
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M17.5 17.5H8.333c-2.75 0-4.124 0-4.979-.854-.854-.855-.854-2.23-.854-4.98V2.5","stroke":"#FBFBFB","stroke-width":"1.5","stroke-linecap":"round"}}),_c('path',{attrs:{"d":"M16.667 14.167v-2.5M13.333 11.667v-5M10 11.667v-2.5M6.667 9.167v-5","stroke":"#FBFBFB","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    